import { IChildProp } from '@intelligence/components/Form/type';

const MOBILE_BENCHMARK: IChildProp[] = [{
  enumKey: 'source',
  enumTargetType: 'downloadMainCategory',
  type: 'checkboxGroup',
  condition: 'additionalFields:sourceTab:kpi_data||additionalFields:sourceTab:player_activity',
  children: [{
    enumKey: 'appannie_mobile',
    enumTargetType: 'dataSource',
    isNoIcon: true,
    defaultSelectCondition: 'additionalFields:sources:[]appannie',
  }, {
    enumKey: 'databrain_mobile',
    enumTargetType: 'dataSource',
    isNoIcon: true,
    defaultSelectCondition: 'additionalFields:sources:[]databrain',
  }],
}, {
  enumKey: 'streamSource',
  enumTargetType: 'downloadMainCategory',
  type: 'checkboxGroup',
  condition: 'additionalFields:sourceTab:social_channels',
  children: [{
    enumKey: 'twitch',
    enumTargetType: 'platformStreaming',
    defaultSelectCondition: 'additionalFields:steamSource:[]twitch',
  },
  {
    enumKey: 'youtube',
    enumTargetType: 'platformStreaming',
    defaultSelectCondition: 'additionalFields:steamSource:[]ytg',
  },
  {
    enumKey: 'facebook',
    enumTargetType: 'platformStreaming',
    defaultSelectCondition: 'additionalFields:steamSource:[]facebook',
  },],
}, {
  enumKey: 'timeScale',
  enumTargetType: 'downloadMainCategory',
  type: 'checkboxGroup',
  condition: 'additionalFields:sourceTab:social_channels',
  children: [{
    label: 'Lifetime',
    labelKey: 'dbi_benchmark_lifetime',
    value: 'lt',
    defaultSelectCondition: 'additionalFields:timeScale:[]lt',
  },
  {
    label: 'Latest 365 days',
    labelKey: 'dbi_benchmark_365d',
    value: '365d',
    defaultSelectCondition: 'additionalFields:timeScale:[]365d',
  },
  {
    label: 'Latest 30 days',
    labelKey: 'dbi_benchmark_30d',
    value: '30d',
    defaultSelectCondition: 'additionalFields:timeScale:[]30d',
  },],
}, {
  enumKey: 'benchmarkMetrics',
  enumTargetType: 'downloadMainCategory',
  type: 'checkboxGroup',
  condition: 'additionalFields:sourceTab:kpi_data',
  children: [{
    label: 'Revenue',
    value: 'revenue',
    defaultSelectCondition: 'additionalFields:metrics:[]revenue',
  }, {
    label: 'Downloads',
    value: 'download',
    defaultSelectCondition: 'additionalFields:metrics:[]download',
  }, {
    label: 'avg.DAU',
    value: 'dau',
    defaultSelectCondition: 'additionalFields:metrics:[]dau',
  }],
}, {
  enumKey: 'basicInformation',
  enumTargetType: 'downloadMainCategory',
  condition: 'additionalFields:sourceTab:kpi_data||additionalFields:sourceTab:player_activity',
  type: 'checkboxGroup',
  children: [{
    enumKey: 'hasCompany',
    enumTargetType: 'downloadBasicInfo',
  }, {
    enumKey: 'hasGenre',
    enumTargetType: 'downloadBasicInfo',
  }, {
    enumKey: 'hasRelease',
    enumTargetType: 'downloadBasicInfo',
  }, {
    enumKey: 'hasRegion',
    enumTargetType: 'downloadBasicInfo',
  }],
}, {
  enumKey: 'dataCalculation',
  enumTargetType: 'downloadMainCategory',
  type: 'subForm',
  className: 'form-item--top-18',
  condition: 'additionalFields:sourceTab:kpi_data',
  children: [{
    enumKey: 'benchmarkPlatformSettings',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      labelKey: 'dbi_benchmark_both',
      value: 'Both'
    }, {
      enumKey: 'ios',
      enumTargetType: 'platformMobile',
    }, {
      enumKey: 'android',
      enumTargetType: 'platformMobile',
    }]
  }, {
    enumKey: 'regionSettings',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'isCountryAggregated',
      enumTargetType: 'downloadDataCalcu',
    }, {
      enumKey: 'isSeperateByRegion',
      enumTargetType: 'downloadDataCalcu',
    }]
  }],
}, {
  enumKey: 'benchmarkPlatformSettings',
  enumTargetType: 'downloadMainCategory',
  type: 'radio',
  condition: 'additionalFields:sourceTab:player_activity',
  children: [{
    isDefault: true,
    labelKey: 'dbi_benchmark_both',
    value: 'Both'
  }, {
    enumKey: 'ios',
    enumTargetType: 'platformMobile',
  }, {
    enumKey: 'android',
    enumTargetType: 'platformMobile',
  }]
}, {
  enumKey: 'dataAmount',
  enumTargetType: 'downloadMainCategory',
  type: 'radio',
  children: [{
    isDefault: true,
    enumKey: 'exportAllData',
    enumTargetType: 'downloadOther',
  }, {
    enumKey: 'selectTop',
    enumTargetType: 'downloadOther',
  }]
}, {
  enumKey: 'selectTop',
  enumTargetType: 'downloadMainCategory',
  type: 'inputNumber',
  // 默认值，带?为变量传入，不带为正常值
  defaultValue: '?additionalFields:initialSelectTop',
  condition: 'dataAmount:top',
}, {
  enumKey: 'fileFormat',
  enumTargetType: 'downloadMainCategory',
  type: 'radio',
  children: [{
    isDefault: true,
    enumKey: 'exportExcel',
    enumTargetType: 'downloadOther',
  }, {
    enumKey: 'exportCSV',
    enumTargetType: 'downloadOther',
  }],
}];

export default {
  mobileBenchmark: MOBILE_BENCHMARK
};
